module.exports = __webpack_public_path__ + "media/flip2.2dd4d944.wav";